/*
  UMD header generated via modularize.js at 2015-04-02T22:08:29.081Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/jquery-1.9.1.min': '$'
})(this, function (m_module, $) {

var M = m_module.M;

M.html = {};

/**
 * HTML escaping using JQuery
 * http://stackoverflow.com/questions/1219860/javascript-jquery-html-encoding
 */
M.html.htmlEscape = function(content) {
  if (content) {
    content = $('<div/>').text(content).html();
  }
  return content;
}

/**
 * HTML ATTRIBUTE (adds ' and ") escaping using JQuery
 * http://stackoverflow.com/questions/1219860/javascript-jquery-html-encoding
 */
M.html.htmlAttributeEscape = function(content) {
  if (content) {
    content = M.html.htmlEscape(content)
      .replace(/'/g, "&#39;")
      .replace(/"/g, "&quot;");
  }
  return content;
}

/**
 * Strips standard control characters out of string - input should be unicode
 *
 * Collapses characters in the range - chars in range:
 * - http://www.cs.tut.fi/~jkorpela/chars/spaces.html
 * - also including u2028 and u2029
 * - \u0000 to \u0020 (standard lower order control chars)
 *
 * - Duplicate logic: Code in src/py/minted/util/text.py
 *   -> unicode_collapse_ctrl_chars function also contains this
 *   logic. Please update changes in both places.
 */
M.html.unicodeStripControlCharacters = function(content) {
  if (content) {
    var pattern = new RegExp('[\u0000-\u0020\u2000-\u200b\u007f-\u009f' +
      '\u00a0\u1680\u180e\u2028\u2029\u202f\u205f\u3000\ufeff]+','g')
    return (content.replace(pattern, '\u0020'));
  }
  return "";
};

return {
};

});
